import axios from 'axios';
import { ApiError } from '../../error';

// Card 119 — the guide advice library.
//
// Content is served rather than bundled so copy edits are a backend deploy
// rather than a release of this app and the Expo app in lockstep. The response
// carries the whole library plus `nextBestModuleId`, which is computed from the
// caller's own account state.
const url = '/api/v1/tipdirect/learn';

export const fetchLearnLibrary = () => {
  return axios
    .get(url)
    .then(res => res.data.data)
    .catch(ApiError.ofAndThrow);
};
